import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames"
import Container from 'react-bootstrap/Container';
import { injectIntl } from "react-intl";
import Loader from "../Common/Loader/Loader";
import messages from "../../locale/messages";
import { useDispatch, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { writeReviewsAction } from "../../actions/reviews/writeReviewsAction";
import bt from '../commonStyle.css';
import s from "./ReviewDoneBanner.css"


function ReviewDoneBanner({ data, intl: { formatMessage } }) {

    const rating = useSelector(state => formValueSelector('ProviderReviewCard')(state, 'rating'))
    const loading = useSelector(state => state.loader.reviewLoading)
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(writeReviewsAction({ userId: data?.partnerId, bookingId: data?.id, authorId: data?.userId, ratings: rating, currency: data?.currency }))
    }

    return (
        <div className={s.paymentDoneBottomBannerContainer}>
            <Container>
                <div className={s.paymentDoneBottomBannerWrapper}>
                    <Loader
                        type={"button"}
                        buttonType={'button'}
                        show={loading}
                        label={formatMessage(messages.done)}
                        handleClick={handleClick}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    />
                </div>
            </Container>
        </div>
    )
}

export default injectIntl(withStyles(bt, s)(ReviewDoneBanner));
